import { send } from "../../send";

/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 报表模块
 */
export const Report = {
    // 报表列表
    getReportList(parmas, expend) {
        return send("GET", "/api/company/extConsumer/find", parmas, expend);
    },
    // 最新电流值列表
    getExtConsumerRecord(parmas, expend) {
        return send("GET", "/api/company/extConsumerRecord/find/latest", parmas, expend);
    },
    // 最新十条电流值
    getExtConsumerRecordTen(parmas, expend) {
        return send("GET", "/api/company/extConsumerRecord/find/Latest/ten", parmas, expend);
    },
    getRecordFroStatistics(parmas, expend) {
        return send("GET", "/api/company/extConsumerRecord/find/all/statistics", parmas, expend);
    },
    // 日报
    getReportDaily(parmas, expend) {
        return send("GET", "/api/company/report/query", parmas, expend);
    },
    //总在线数据
    getOnlineList(parmas, expend) {
        return send("GET", "/api/company/extConsumerRecord/online", parmas, expend);
    },
    //站点最新状态
    getLastOnlineStatus(parmas, expend) {
        return send("GET", "/api/company/extConsumerRecord/online/status", parmas, expend);
    },
    /**
     * 手工录入数据
     */
    // 查询列表
    getDataManualInputList(parmas, expend) {
        return send("GET", "/api/company/data/manual/input/find", parmas, expend);
    },
    // 添加
    postDataManualInputAdd(parmas, expend) {
        return send("POST", "/api/company/data/manual/input/create", parmas, expend);
    },
    // 修改
    postDataManualInputEdit(parmas, expend) {
        return send("POST", "/api/company/data/manual/input/modify", parmas, expend);
    },
    // 删除
    postDataManualInputDel(parmas, expend) {
        return send("GET", "/api/company/data/manual/input/del/" + parmas.content.id, {}, expend);
    },
    // 获取排口类型
    getDataManualInputType(parmas, expend) {
        return send("GET", "/api/company/data/manual/input/type", parmas, expend);
    },
}